document.addEventListener('DOMContentLoaded', function () {

  const historyContainer = document.getElementById('subscriptionHistoryContainer');
  const historyContent = document.getElementById('subscriptionHistoryContent');
  const customerIdInput = document.getElementById('tjcCustomerId');

  if ( !historyContainer || !customerIdInput ) {
    return;
  }

  async function loaderHistoryData () {
    
      historyContent.innerHTML = `
        <div class="tjc-no-history">
          Loading payment history...
        </div>
      `;

      const customerId = customerIdInput.value;

      if (!customerId) {
        historyContent.innerHTML = `
          <div class="tjc-no-history">
            Customer ID not found.
          </div>
        `;
        return;
      }

      try {
        console.log("FETCH START");
        const apiUrl =
        `/apps/membership/subscription-history?customerId=${customerId}`;

        console.log("API URL:", apiUrl);
        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error(
            'API response failed'
          );
        }

        const responseData = await response.json();
        console.log("responseData ",responseData)
        const data = responseData?.data?.history || [];

        if (
          !data ||
          !Array.isArray(data) ||
          data.length === 0
        ) {
          historyContent.innerHTML  = `
            <div class="tjc-no-history">No payment history found.</div>
          `;
          return;
        }

        let html = `
         <div class="tjc-history-table">
          <div class="fs_15 fw_7 txt_b tjc-history-header">
            <div>Membership Name</div>
            <div>Payment Date</div>
            <div>Amount Paid</div>
          </div>
         </div>
        `;

        data.forEach(function (item) {
          html += `
            <div class="tjc-history-row">
              <div class="tjc-col">
                ${item.membershipType || '-'}
              </div>
              <div class="tjc-col">
                ${formatDate(item.paymentDate)}
              </div>
              <div class="tjc-col amount">
                £${item.amount || '0'}
              </div>
            </div>
          `;
        });

        historyContent.innerHTML  = html;
        historyContainer.dataset.loaded = 'true';
      } catch (error) {
        console.error('Subscription History Error:',
          error
        );
        historyContent.innerHTML = `
          <div class="tjc-no-history">Unable to load payment history.</div>
        `;
      }
  }
  
    if(customerIdInput){
      loaderHistoryData();
    }

});

function formatDate(dateString) {
  if (!dateString) {
    return '-';
  }

  const parts = dateString.split('/');

  if (parts.length !== 3) {
    return dateString;
  }

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  const date = new Date(year, month, day);

  if (isNaN(date.getTime())) {
    return dateString;
  }

  return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    }
  );
}